import React, { useCallback } from "react";
import { ChartTitle, ChartWrapper, SelectedQuestionContainer, SelectedQuestionIndex, SelectedQuestionTitle } from "./style";
import { chartOrder } from "src/sections/ReportManager/constants";
import { useReport } from "src/sections/ReportManager/context/ReportContext";
import { ExpandableChart } from "./components/ExpandableChart";
import { ReportSimpleChart } from "./components/ReportSimpleChart";
import { ReportEvolutiveChart } from "./components/ReportEvolutiveChart";
import { ReportSimplesCrossChart } from "./components/ReportSimpleCrossChart";

/**
 * O gráfico simples é de exportação obrigatória: ele é a origem das cores que o
 * evolutivo herda e a garantia de que a pergunta leva ao menos um gráfico para o
 * relatório. Sem nenhum gráfico o gerador não consegue montar o documento.
 *
 * TODO: TEN-2977 - remover esta obrigatoriedade quando o docx-report aceitar
 * relatório sem nenhum gráfico, liberando a exportação só de cruzamento simples.
 */
const TIPO_GRAFICO_OBRIGATORIO = 'GERAIS';
const HINT_GRAFICO_OBRIGATORIO =
  'Se esta pergunta for selecionada, o gráfico simples é sempre exportado no relatório';

export const SelectedQuestion = ({
  // Pergunta selecionada
  selectedQuestion,
}) => {

  const { questionConfig, setQuestionConfig } = useReport();

  const onCheck = useCallback((id) => {
    setQuestionConfig((prevConfig) => ({
      ...prevConfig,
      [selectedQuestion.id]: {
        ...prevConfig[selectedQuestion.id],
        graficos: prevConfig[selectedQuestion.id].graficos.map((grafico) =>
          grafico.id === id && grafico.tipo !== TIPO_GRAFICO_OBRIGATORIO
            ? { ...grafico, checked: !grafico.checked }
            : grafico
        ),
      },
    }));
  }, [selectedQuestion, setQuestionConfig]);

  const chartEdit = useCallback((newChartData) => {
    setQuestionConfig((prevConfig) => ({
      ...prevConfig,
      [selectedQuestion.id]: {
        ...prevConfig[selectedQuestion.id],
        graficos: prevConfig[selectedQuestion.id].graficos.map((grafico) => 
          grafico.id === newChartData.id ? newChartData : grafico
        ),
      },
    }));
  }, [selectedQuestion, setQuestionConfig]);

  return (
    <SelectedQuestionContainer>
      <SelectedQuestionIndex>Pergunta { selectedQuestion.index }</SelectedQuestionIndex>
      <SelectedQuestionTitle>{ selectedQuestion.enunciado }</SelectedQuestionTitle>

      <ChartTitle>Gerar gráficos</ChartTitle>
      <ChartWrapper>
        {
          questionConfig[selectedQuestion.id]?.graficos
            ?.sort((a, b) => chartOrder[a.tipo] - chartOrder[b.tipo])
            ?.map((chart, index) => {
            return (
              <ExpandableChart
                key={index}
                title={chart.title}
                onCheck={onCheck}
                id={chart.id}
                checked={chart.checked}
                locked={chart.tipo === TIPO_GRAFICO_OBRIGATORIO}
                lockedHint={HINT_GRAFICO_OBRIGATORIO}
              >
                {chart.tipo === 'GERAIS' && <ReportSimpleChart onChartEdit={chartEdit} chartData={chart} />}
                {chart.tipo === 'CRUZAMENTO_SIMPLES' && <ReportSimplesCrossChart onChartEdit={chartEdit} chartData={chart} />}
                {chart.tipo === 'EVOLUTIVO' && <ReportEvolutiveChart onChartEdit={chartEdit} chartData={chart} />}
              </ExpandableChart>
            )
          })
        }
      </ChartWrapper>
    </SelectedQuestionContainer>
  )
}